import { createBrowserRouter } from "react-router-dom";

import MainLayout from "../Pages/MainLayout/MainLayout.jsx";
import Authentication from "../Pages/Authentication/Authentication.jsx";
import Login from "../Pages/Auth/Login/Login.jsx";
import ForgetPassword from "../Pages/Auth/ForgetPassword/ForgetPassword.jsx";
import Verifying from "../Pages/Auth/Verifying/Verifying.jsx";
import VerifycationFaild from "../Pages/Auth/VerifycationFailed/VerifycationFailed.jsx";
import Succssefully from "../Pages/Auth/Succssefully/Succssefully.jsx";
import ResetPassword from "../Pages/Auth/ResetPassword/ResetPassword.jsx";
import DashboardLayout from "../Pages/Dashboard/Layout/DashboardLayout.jsx";
import DashboardHome from "../Pages/Dashboard/DashboardHome/DashboardHome.jsx";
import SiteActivity from "../Pages/SiteActivity/SiteActivity.jsx";
import WidgetsWeb from "../Pages/WidgetsWeb/WidgetsWeb.jsx";
import WidgetsSales from "../Pages/WidgetsSales/WidgetsSales.jsx";
import Neworders from "../Pages/Neworders/Neworders.jsx";
import WidgetsMarketing from "../Pages/WidgetsMarketing/WidgetsMarketing.jsx";
import CancelledOrders from "../Pages/Cancelledorders/Cancelledorders.jsx";
import Allorders from "../Pages/Allorders/Allorders.jsx";
import SalesMovement from "../Pages/SalesMovement/SalesMovement.jsx";
import ViewDetails from "../Pages/ViewDetails/ViewDetails.jsx";
import StockandEdit from "../Pages/StockandEdit/StockandEdit.jsx";
import EditProduct from "../Pages/EditProduct/EditProduct.jsx";
import AddNewPage from "../Pages/AddNewPage/AddNewPage.jsx";
import AddNewProductss from "../Pages/AddNewProductss.jsx";
import ProductReviewsModal from "../Pages/ProductReviewsModal.jsx";
import StockMovementEdit from "../Pages/StockMovementEdit.jsx";
import AddNewservieses from "../Pages/AddNewservieses/AddNewservieses.jsx";
import Profile from "../Pages/Profile/Profile.jsx";
import SettingsInformation from "../Pages/SettingsInformation/SettingsInformation.jsx";
import PersonalInfo from "../Pages/PersonalInfo.jsx";
import WorkTeam from "../Pages/WorkTeam/WorkTeam.jsx";
import CreatAccount from "../Pages/CreatAccount/CreatAccount.jsx";
import Teampermissions from "../Pages/Teampermissions/Teampermissions.jsx";
import HelpCenter from "../Pages/HelpCenter/HelpCenter.jsx";
import SupportFaqs from "../Pages/SupportFaqs/SupportFaqs.jsx";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy.jsx";
import Request from "../Pages/Request/Request.jsx";
import Replay from "../Pages/Replay/Replay.jsx";
import MarketingStatistics from "../Pages/MarketingStatistics/MarketingStatistics.jsx";
import Creatlinks from "../Pages/Creatlinks/Creatlinks.jsx";
import Linksociailmedia from "../Pages/Linksociailmedia/Linksociailmedia.jsx";
import AdsB1 from "../Pages/AdsB1/AdsB1.jsx";
import AdsB2 from "../Pages/AdsB2/AdsB2.jsx";
import AdsB3 from "../Pages/AdsB3/AdsB3.jsx";
import Clients from "../Pages/Clients/Clients/Clients.jsx";
import Informations from "../Pages/Clients/Informations/Informations.jsx";
import Orders from "../Pages/Clients/Orders/Orders.jsx";
import Payments from "../Pages/Clients/Payments/Payments.jsx";
import Products from "../Pages/Clients/E-Marketing/Products/Products.jsx";
import Website from "../Pages/Clients/E-Marketing/Website/Website.jsx";
import Links from "../Pages/Clients/E-Marketing/Links/Links.jsx";
import Notices from "../Pages/Clients/Notices/Notices.jsx";
import Movement from "../Pages/Payments/Movement/Movement.jsx";
import AllPayments from "../Pages/Payments/AllPayments/AllPayments.jsx";
import SuccessedPayment from "../Pages/Payments/SuccessedPayment/SuccessedPayment.jsx";
import RefundedPayment from "../Pages/Payments/RefundedPayment/RefundedPayment.jsx";
import SalesInvoice from "../Pages/Payments/SalesInvoice/SalesInvoice.jsx";
import Notifications from "../Pages/Notifications/Notifications.jsx";
import NotificationRings from "../Pages/Notifications/NotificationRings/NotificationRings.jsx";
import SendNotes from "../Pages/Notifications/SendNotes/SendNotes.jsx";
const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          path: "/",
          element: <Authentication />,
          children: [
            { index: true, element: <Login /> },
            { path: "login", element: <Login /> },
            { path: "forgetpassword", element: <ForgetPassword /> },
            { path: "verify-code", element: <Verifying /> },
            { path: "verification-failed", element: <VerifycationFaild /> },
            { path: "verification-succsses", element: <Succssefully /> },
            { path: "reset-password", element: <ResetPassword /> },
          ],
        },
      ],
    },

    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { index: true, element: <DashboardHome/> },
        { path: "SiteActivity", element: <SiteActivity/> },
        { path: "WidgetsWeb", element: <WidgetsWeb/> },
        { path: "WidgetsSales", element: <WidgetsSales/> },
        { path: "WidgetsMarketing", element: <WidgetsMarketing/> },
        { path: "Neworders", element: <Neworders/> },
        { path: "Cancelledorders", element: <CancelledOrders/> },
        { path: "Allorders", element: <Allorders/> },
        { path: "sales-movement", element: <SalesMovement/> },
        { path: "ViewDetails", element: <ViewDetails/> },
        { path: "StockandEdit", element: <StockandEdit/> },
        { path: "EditProduct", element: <EditProduct/> },
        { path: "AddNewPage", element: <AddNewPage/> },
        { path: "AddNewProductss", element: <AddNewProductss/> },
        { path: "ProductReviewsModal", element: <ProductReviewsModal/> },
        { path: "StockMovementEdit", element: <StockMovementEdit/> },
        { path: "AddNewservieses", element: <AddNewservieses/> },
        { path: "Profile", element: <Profile/> },
        { path: "Settings-Informations", element: <SettingsInformation/> },
        { path: "PersonalInfo", element: <PersonalInfo/> },
        { path: "workteam", element: <WorkTeam/> },
        { path: "Teampermissions", element: <Teampermissions/> },
        { path: "HelpCenter", element: <HelpCenter/> },
        { path: "SupportFaqs", element: <SupportFaqs/> },
        { path: "PrivacyPolicy", element: <PrivacyPolicy/> },
        { path: "MarketingStatistics", element: <MarketingStatistics/> },
        { path: "Creatlinks", element: <Creatlinks/> },
        { path: "Linksociailmedia", element: <Linksociailmedia/> },
               { path: "AdsB1", element: <AdsB1/> },
                  { path: "AdsB2", element: <AdsB2/> },
                   { path: "AdsB3", element: <AdsB3/> },
                     { path: "Clients", element: <Clients/> },
                       { path: "Informations", element: <Informations/> },
             { path: "Client-Orders", element: <Orders/> },
             { path: "Client-Payments", element: <Payments/> },
                  { path: "Emarketing-products", element: <Products/> },
                    { path: "Emarketing-Website", element: <Website/> },
                        { path: "Emarketing-Links", element: <Links/> },
                            { path: "Client-Notices", element: <Notices/> },
              { path: "Request", element: <Request/> },
 { path: "Replay", element: <Replay/> },
         { path: "CreatAccount", element: <CreatAccount/> },
            { path: "Movement", element: <Movement/> },
             { path: "All-Payments", element: <AllPayments/> },
                         { path: "Successed-Payments", element: <SuccessedPayment/> },
                         { path: "Refunded-Payments", element: <RefundedPayment/> },
                          { path: "Sales-Invoice", element: <SalesInvoice/> },
                          { path: "Notifications", element: <Notifications/> },
                          { path: "Notification-Rings", element: <NotificationRings/> },
{ path: "Send-Notes", element: <SendNotes/> },
         
      ],
    },

  
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true,
    },
  }
);

export default router;
